import { X } from '@phosphor-icons/react';
import type { ReactNode } from 'react';

interface BottomSheetProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  maxHeight?: string;
  children: ReactNode;
}

export default function BottomSheet({
  open,
  onClose,
  title,
  maxHeight = '75vh',
  children,
}: BottomSheetProps) {
  if (!open) return null;

  return (
    <div className="lg:hidden fixed inset-0 z-50">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      <div
        className="absolute bottom-0 left-0 right-0 bg-white dark:bg-gray-900 rounded-t-2xl animate-slideUp flex flex-col"
        style={{ maxHeight, paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}
      >
        {/* Drag handle */}
        <div className="flex justify-center pt-3 pb-1">
          <div className="w-10 h-1 rounded-full bg-gray-300 dark:bg-gray-600" />
        </div>
        {/* Header */}
        {title && (
          <div className="flex items-center justify-between px-4 pb-2">
            <h3 className="text-sm font-semibold text-gray-700 dark:text-gray-300">{title}</h3>
            <button
              onClick={onClose}
              className="p-1 text-gray-400 dark:text-gray-500 hover:text-gray-600 dark:hover:text-gray-400"
            >
              <X size={20} />
            </button>
          </div>
        )}
        {/* Scrollable content */}
        <div className="flex-1 overflow-y-auto min-h-0 px-4 pb-4">
          {children}
        </div>
      </div>
    </div>
  );
}
